import React from "react";

import {
  Box,
  Stack,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
} from "@mui/material";
import { Typography } from "components";
import Link from "components/utils/Link";
import { Paths } from "configs";
import { rem } from "utils";

interface Props {
  title: string;
  fullName: string;
  email: string;
  id: number;
}

const UserDetail = (props: Props) => {
  const { title = "", fullName = "", id, email } = props;
  return (
    <List
      sx={{
        width: "100%",
        maxWidth: 360,
        bgcolor: "background.paper",
        padding: 0,
      }}
    >
      <ListItem sx={{ padding: "8px" }} alignItems="center">
        <ListItemAvatar>
          <Avatar alt="avatar">{fullName[0]}</Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <Link to={`${Paths.EmployeesDetail}/${id}`}>
              <Typography type="TextSM">{fullName}</Typography>
            </Link>
          }
          secondary={
            <Typography type="TextSM">
              <strong>{title}</strong> <br /> <i>{email}</i>
            </Typography>
          }
        />
      </ListItem>
    </List>
  );
};

const NodeUser = (props: Props) => {
  const { fullName } = props;
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const idPopover = open ? "simple-popover" : undefined;

  return (
    <Box display="inline-block" minWidth={rem(50)} sx={{ cursor: "pointer" }}>
      <Stack alignItems="center" rowGap={rem(12)} maxWidth="100px">
        <Avatar alt="avatar">{fullName[0]}</Avatar>
        <Typography
          sx={{ wordBreak: "initial" }}
          fontWeight={500}
          onClick={handleClick}
        >
          {fullName}
        </Typography>
      </Stack>

      <Popover
        id={idPopover}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <UserDetail {...props} />
      </Popover>
    </Box>
  );
};

export default NodeUser;
